import axios from "axios";
import { base_url } from "../../utils/baseUrl";

const createBooking = async (bookingData) => {
    console.log(bookingData,"booking data")
  const response = await axios.post(`${base_url}booking/`, bookingData, {
   });
  return response.data;
};



const bookingService = {
  createBooking,
};

export default bookingService;